export default {
  methods: {
    inputErrors(e) {
      if (e.length)
        e.forEach(error => {
          this.$validator.errors.add({
            field: error.source.pointer.split("/").pop(),
            msg: error.title
          });
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/errorMixin.js